import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AlbaranService {

  static PATH = environment.API_BASE + '/Albaran/';
  DOCUMENTS_PATH = environment.API_BASE + '/Documentos';

  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService) { }

  impresionLocation(idContenido: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getDocumentLocation?idContenido=${idContenido}`, { responseType: 'arraybuffer' });
  }

  impresionCartela(idContenido: number, idOrden: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getDocumentCartela?idContenido=${idContenido}&idOrden=${idOrden}`, { responseType: 'arraybuffer' });
  }

  impresionTestigo(idContenido: number, idOrden: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getDocumentTestigo?idContenido=${idContenido}&idOrden=${idOrden}`, { responseType: 'arraybuffer' });
  }

  impresionAlbaran(idContenido: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getAlbaran?idContenido=${idContenido}`, { responseType: 'arraybuffer' });
  }

  impresionPeticionPalet(idContenido: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getPeticionPalet?idContenido=${idContenido}`, { responseType: 'arraybuffer' });
  }

  impresionTodo(idContenido: number, idOrden: number): Observable<ArrayBuffer> {
    return this.http.get(`${this.DOCUMENTS_PATH}/getAllDocuments?idContenido=${idContenido}&idOrden=${idOrden}`, { responseType: 'arraybuffer' });
  }

  getAlbaranSolicitud(idSolicitud: number) {
    let theFile;
    this.http.get(`${AlbaranService.PATH}${idSolicitud}/${(new Date()).getTimezoneOffset()}`, { responseType: 'blob' }).subscribe(data => {
      theFile = new Blob([data], { type: 'application/octet-stream' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        console.log('a');
        window.navigator.msSaveOrOpenBlob(theFile, idSolicitud + '.pdf');
      } else {
        const a = document.createElement('a');
        const blob = new Blob([data], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = idSolicitud + '.pdf';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 100);
      }
    },
      error => {
        this.translate.get(['albaranes'])
          .subscribe(values => {
            this.toastr.warning(values['albaranes']['nodata'],
              values['albaranes']['nodatatitle']);
          });
      });
  }

  getAlbaranSolicitudBlob(idSolicitud: number): Observable<any> {
    return this.http.get(`${AlbaranService.PATH}${idSolicitud}/${(new Date()).getTimezoneOffset()}`, { responseType: 'blob' });
  }

  checkQRText(qrText: string) {
    return this.http.get(`${AlbaranService.PATH}LecturaQR/${encodeURIComponent(qrText)}`);
  }
}
